import { Box, Typography } from '@mui/material';
import { useGetCall } from 'common/api/useApiCall';
import BackButton from 'common/custom-components/lib/components/BackButton';
import { TENANTS_BASE_URL, URLS } from 'constants/URL';
import { useEffect, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import DBServersDetailsTabView from './DBServerDetailsTabView';
import { tenantByIdResponseAdapter } from 'common/TenantContainer/tenantByIdResponseAdapter';
import LoadingOverlay from 'common/custom-components/lib/components/LoadingOverlay';
import { SoftwareImageVersionInfo } from './SoftwareImageVersionInfo';

const DBServersDetailedView = () => {
  const params = useParams();
  const navigate = useNavigate();

  const {
    response: dBServersResponse,
    isLoading: dBServersLoading,
    postData: fetchDBServers,
  } = useGetCall(
    `${URLS.fetchComputesProxy}tenant-domain=${params?.tenantDomain}&tenant-id=${params.tenantId}&id=${params.dbServerId}`,
  );

  const {
    response: tenantResponse,
    isLoading: tenantIsLoading,
    postData: fetchTenantByID,
  } = useGetCall(
    `${TENANTS_BASE_URL}/${params.tenantId}`,
    tenantByIdResponseAdapter,
  );

  const dbServer = useMemo(() => {
    const list = dBServersResponse?.response;
    if (Array.isArray(list)) {
      return (
        list.find(
          (s) => s?.id === params.dbServerId || s?._id === params.dbServerId,
        ) || null
      );
    }
    // Some APIs return a single object directly.
    if (dBServersResponse?.id || dBServersResponse?._id) {
      return dBServersResponse;
    }
    return null;
  }, [dBServersResponse, params.dbServerId]);

  useEffect(() => {
    if (params['*'] === '') {
      navigate('overview');
    }
  }, []);

  return (
    <div className="page-content vh-100">
      <LoadingOverlay
        isLoading={
          tenantIsLoading ||
          dBServersLoading ||
          !tenantResponse?._id ||
          !(dbServer?.id || dbServer?._id)
        }
      >
        <Box display="flex" flexDirection="column" px={4} pb={2} pt={1}>
          <BackButton />
          <Typography
            variant="h5"
            pb={2}
            sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
          >
            {dbServer?.name}
            {dbServer && <SoftwareImageVersionInfo dbServer={dbServer} />}
          </Typography>

          <div>
            <DBServersDetailsTabView tenant={tenantResponse} dbServer={dbServer} />
          </div>
        </Box>
      </LoadingOverlay>
    </div>
  );
};

export default DBServersDetailedView;
